import { create } from 'zustand';

import { USER_ROLES } from '@/constants/global-constants';
import { privateRoutes } from '@/constants/route-settings';

interface SettingsTabStore {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export const useSettingsTabStore = create<SettingsTabStore>((set) => ({
  activeTab: privateRoutes[USER_ROLES.ADMIN.value].fileValidation,
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
